module.exports = __webpack_public_path__ + "static/Grafika7-490dbc26110358c949415ddbe35bdbe7.png";